export const cookiePrefixesToPickUp = [
  'utm',
  'afuserid',
  'r=',
  'ttclid',
  '_ga=',
  '_ga_VYHG5X0XGR=',
  'af_c_id',
  'af_adset_id',
  'af_ad_id',
  'af_adset',
  'af_keyword_id',
  'gclid',
  'msclkid',
  'pscd',
  'ps_partner_key',
  'ps_xid',
  'gsxid',
  'gspk',
];

export const LILI_SUPPORT_PHONE = '(855) 545-4380';
export const LILI_SUPPORT_EMAIL = 'support@lili.co';
export const LILI_TERMS_OF_USE_URL = 'https://lili.co/legal-documents/lili-terms-of-use';
export const LILI_PRIVACY_POLICY_URL = 'https://lili.co/legal-documents/lili-privacy-policy';
export const SUNRISE_ACCOUNT_MANAGMENT_AGREEMENT_URL =
  'https://lili.co/legal-documents/sunrise-customer-agreement';
export const SUNRISE_PRIVACY_POLICY_AGREEMENT_URL =
  'https://lili.co/legal-documents/privacy-notice-sunrise';
export const SUNRISE_APPLE_AND_GOOGLE_PAY_TERMS_URL =
  'https://lili.co/legal-documents/sunrise-apple-google-pay-terms';
export const LILI_BIOMETRIC_DATA_CONSENT_URL = 'https://lili.co/legal-documents/7284-2';
export const SUNRISE_VISA_SAVINGS_EDGE_TERMS_URL =
  'https://lili.co/legal-documents/sunrise-visa-savingsedge-terms';

export const SUBMIT_BUTTON_ID = 'formSubmitButton';

export enum PASSWORD_LESS_PARTNER_IDS_MAP {
  DNB_INTEG_1 = '8a4ea8ca-470f-4be7-a2ef-69508be415ec',
  DNB_INTEG_2 = '8b745cdb-03bf-4dad-a64d-0dd6638d0848',
  DNB_PROD = 'cc2f7c20-4c39-4272-b538-588361dee3e6',
  LILI_PARTNER = '9e584dfc-c7c2-4ce6-bc3a-e680013528be',
  WYOMING_INTEG = 'd75a1bc7-10a0-44dc-bd43-05b0e7bd7c13',
  WYOMING_SAGE = '851b5217-872d-41a4-b6bf-a45a543e23b5',
  US_CORPORATE_SOLUTIONS = '20904a03-d11a-4382-81a5-c35b58b00ccb',
  DIRECT_INCORPORATION = 'd483bfe9-8e6a-4ec7-8009-e5c18535084e',
  PROZDESK = '135a0679-4958-4dd5-a5f8-596fcd92705e',
  DNB = 'c3f12798-00de-47ac-9338-e674470ea66e',
  CIRCLE_CLUB = '7418a338-de08-40d4-864a-4553fbcdda2f',
  STAATENLOS = '4a116dcd-f9bd-49f1-95e5-1fd40ff25a7c',
  ONTECH = 'b67d15c7-b29c-4b4f-ae77-70f0c5224d7b',
  MATRIX_USA = '73e4806d-aa77-44dc-b4f5-3482db8d0001',
  CONVESIO = '6bc41bbc-d10c-43f1-8a8d-4b2e484177eb',
  USA_CORPORATION_SERVICES = 'e02b9583-0cd4-40fd-b0e3-cc642b842e48',
  PLEDGE_VENTURES = 'cd40dbbe-7948-4a55-b2af-2dc84f502d55',
  BUSINESS_ROCKET = '4e76a459-f7be-4b43-9647-6ae67779f018',
  EXPERTLLCUSA = 'f71256d8-dff0-4f88-bcd6-0154874585b5',
  GLOBALFY = 'acd7bf70-989c-4f42-a7e6-8c28765b9cd7',
  EZFRONTIERS = '9ea68b70-103d-4284-bd44-ef0d7750eed1',
  LLC_NEGOCIO_LEGAL = 'a20d5e2a-3dcf-4beb-b117-daed3d20509c',
  OPENBIZ = '769d8cc8-5a6c-4cde-aca3-4de4985c1d4e',
  MERCHANT_INDUSTRY = '9c1115f5-8943-4282-9ac0-06b0ad32f059',
  FLATFEECORP = 'a31c5578-4dc1-4c54-8160-ba7c49213b66',
  ACCOUNTANT_1800 = '4ba67403-8e75-4a24-ba64-6a773082404c',
  LENDIO = '013399f9-e3d5-4082-a054-8b4f336ef5bf',
}

export const PARTNER_FLOW_IDS_MAP = {
  [PASSWORD_LESS_PARTNER_IDS_MAP.DNB_PROD]: 'Dnb embedded',
  [PASSWORD_LESS_PARTNER_IDS_MAP.DNB_INTEG_1]: 'Dnb embedded',
  [PASSWORD_LESS_PARTNER_IDS_MAP.DNB_INTEG_2]: 'Dnb embedded',
  [PASSWORD_LESS_PARTNER_IDS_MAP.LILI_PARTNER]: 'Lili partner',
  [PASSWORD_LESS_PARTNER_IDS_MAP.WYOMING_INTEG]: 'Wyoming/Sage embedded',
  [PASSWORD_LESS_PARTNER_IDS_MAP.WYOMING_SAGE]: 'Wyoming/Sage embedded',
  [PASSWORD_LESS_PARTNER_IDS_MAP.US_CORPORATE_SOLUTIONS]: 'US_CORPORATE_SOLUTIONS',
  [PASSWORD_LESS_PARTNER_IDS_MAP.DIRECT_INCORPORATION]: 'DIRECT_INCORPORATION',
  [PASSWORD_LESS_PARTNER_IDS_MAP.PROZDESK]: 'PROZDESK',
  [PASSWORD_LESS_PARTNER_IDS_MAP.DNB]: 'DNB',
  [PASSWORD_LESS_PARTNER_IDS_MAP.CIRCLE_CLUB]: 'CIRCLE_CLUB',
  [PASSWORD_LESS_PARTNER_IDS_MAP.STAATENLOS]: 'STAATENLOS',
  [PASSWORD_LESS_PARTNER_IDS_MAP.ONTECH]: 'ONTECH',
  [PASSWORD_LESS_PARTNER_IDS_MAP.MATRIX_USA]: 'MATRIX_USA',
  [PASSWORD_LESS_PARTNER_IDS_MAP.CONVESIO]: 'CONVESIO',
  [PASSWORD_LESS_PARTNER_IDS_MAP.USA_CORPORATION_SERVICES]: 'USA_CORPORATION_SERVICES',
  [PASSWORD_LESS_PARTNER_IDS_MAP.PLEDGE_VENTURES]: 'PLEDGE_VENTURES',
  [PASSWORD_LESS_PARTNER_IDS_MAP.BUSINESS_ROCKET]: 'BUSINESS_ROCKET',
  [PASSWORD_LESS_PARTNER_IDS_MAP.EXPERTLLCUSA]: 'EXPERTLLCUSA',
  [PASSWORD_LESS_PARTNER_IDS_MAP.GLOBALFY]: 'GLOBALFY',
  [PASSWORD_LESS_PARTNER_IDS_MAP.EZFRONTIERS]: 'EZFRONTIERS',
  [PASSWORD_LESS_PARTNER_IDS_MAP.LLC_NEGOCIO_LEGAL]: 'LLC_NEGOCIO_LEGAL',
  [PASSWORD_LESS_PARTNER_IDS_MAP.OPENBIZ]: 'OPENBIZ',
  [PASSWORD_LESS_PARTNER_IDS_MAP.MERCHANT_INDUSTRY]: 'MERCHANT_INDUSTRY',
  [PASSWORD_LESS_PARTNER_IDS_MAP.FLATFEECORP]: 'FLATFEECORP',
  [PASSWORD_LESS_PARTNER_IDS_MAP.ACCOUNTANT_1800]: '1800_ACCOUNTANT',
  [PASSWORD_LESS_PARTNER_IDS_MAP.LENDIO]: 'LENDIO',
  CONTROL: 'Control',
} as const;

export const SAGE_PARTNER_IDS = [
  PASSWORD_LESS_PARTNER_IDS_MAP.WYOMING_SAGE,
  PASSWORD_LESS_PARTNER_IDS_MAP.WYOMING_INTEG,
] as const;

export type SagePartnerIds = (typeof SAGE_PARTNER_IDS)[number];
export type PartnerFlowIds = (typeof PARTNER_FLOW_IDS_MAP)[keyof typeof PARTNER_FLOW_IDS_MAP];

export const USA_STATES_LIST = [
  { title: 'AK', value: 'AK' },
  { title: 'AL', value: 'AL' },
  { title: 'AR', value: 'AR' },
  { title: 'AZ', value: 'AZ' },
  { title: 'CA', value: 'CA' },
  { title: 'CO', value: 'CO' },
  { title: 'CT', value: 'CT' },
  { title: 'DC', value: 'DC' },
  { title: 'DE', value: 'DE' },
  { title: 'FL', value: 'FL' },
  { title: 'GA', value: 'GA' },
  { title: 'HI', value: 'HI' },
  { title: 'IA', value: 'IA' },
  { title: 'ID', value: 'ID' },
  { title: 'IL', value: 'IL' },
  { title: 'IN', value: 'IN' },
  { title: 'KS', value: 'KS' },
  { title: 'KY', value: 'KY' },
  { title: 'LA', value: 'LA' },
  { title: 'MA', value: 'MA' },
  { title: 'MD', value: 'MD' },
  { title: 'ME', value: 'ME' },
  { title: 'MI', value: 'MI' },
  { title: 'MN', value: 'MN' },
  { title: 'MO', value: 'MO' },
  { title: 'MS', value: 'MS' },
  { title: 'MT', value: 'MT' },
  { title: 'NC', value: 'NC' },
  { title: 'ND', value: 'ND' },
  { title: 'NE', value: 'NE' },
  { title: 'NH', value: 'NH' },
  { title: 'NJ', value: 'NJ' },
  { title: 'NM', value: 'NM' },
  { title: 'NV', value: 'NV' },
  { title: 'NY', value: 'NY' },
  { title: 'OH', value: 'OH' },
  { title: 'OK', value: 'OK' },
  { title: 'OR', value: 'OR' },
  { title: 'PA', value: 'PA' },
  { title: 'RI', value: 'RI' },
  { title: 'SC', value: 'SC' },
  { title: 'SD', value: 'SD' },
  { title: 'TN', value: 'TN' },
  { title: 'TX', value: 'TX' },
  { title: 'UT', value: 'UT' },
  { title: 'VA', value: 'VA' },
  { title: 'VT', value: 'VT' },
  { title: 'WA', value: 'WA' },
  { title: 'WI', value: 'WI' },
  { title: 'WV', value: 'WV' },
  { title: 'WY', value: 'WY' },
];

export const NAVIGATION_STACK_VERSION = 8;

export const MAIN_INCOME_SOURCE = {
  S_CORP: 'S_CORP',
  C_CORP: 'C_CORP',
  GENERAL_PARTNERSHIP: 'GENERAL_PARTNERSHIP',
  LIMITED_LIABILITY_PARTNERSHIP: 'LLP',
  LLC: 'LLC',
  SOLE_PROP_DBA: 'DBA',
  SOLE_PROP_NO_DBA: 'SSN',
  NON_PROFIT: 'NON_PROFIT',
} as const;
export type MAIN_INCOME_SOURCE = (typeof MAIN_INCOME_SOURCE)[keyof typeof MAIN_INCOME_SOURCE];
